import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export type KencoFlashMileageStop = {
  zip?: string;
  city?: string;
  state?: string;
  country?: string;
};

export type GetKencoFlashMileageRequest = {
  // Ordered stop list (preferred). First = origin, last = destination.
  stops?: KencoFlashMileageStop[];
  origin: KencoFlashMileageStop;
  destination: KencoFlashMileageStop;
  equipmentType?: string;
  customerId?: string;
  pickupDate?: string;
  deliveryDate?: string;
  intermediateStops?: number;
  pricingIntegrationId?: number;
};

export type GetKencoFlashMileageResponse = {
  miles: number;
  source: string;
  equipmentType?: string;
  calculatedTransitDays?: number;
  billableLayoverDays?: number;
};

/** Lane mileage for MGB Rate Per Mile via private calculate-distance endpoint. */
export async function getKencoFlashMileage(
  request: GetKencoFlashMileageRequest
): Promise<Result<GetKencoFlashMileageResponse, ApiError>> {
  try {
    const { data } = await axios.post<GetKencoFlashMileageResponse>(
      '/quote/private/calculate-distance',
      request
    );
    return ok(data);
  } catch (error: unknown) {
    captureException(error, { functionName: 'getKencoFlashMileage' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get mileage from Kenco Flash' });
    }

    const message =
      typeof error.response?.data === 'string'
        ? error.response.data
        : error.response?.data?.message ||
          'Failed to get mileage from Kenco Flash';

    return err({ message });
  }
}
